import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

export type TournamentEventCatalog = Schema["TournamentEventCatalog"];
export type EventCatalogItem = Schema["EventCatalogItem"];

/**
 * The public event catalog (#2691, GET /tournaments/{id}/event-catalog,
 * anonymous-readable): each event's format and guarantee, entry rules line,
 * spots taken and waitlist, plus the list header and footer lines.
 *
 * It sits under the events key so anything that refreshes events (entering,
 * withdrawing) refreshes the counts too. It is display-only: a failed read
 * leaves the event rows as they were, with no banner over the list.
 */
export function useTournamentEventCatalog(tournamentId: string | undefined) {
  return useQuery<TournamentEventCatalog>({
    queryKey: [...queryKeys.tournaments.events(tournamentId ?? ""), "catalog"],
    queryFn: () => tournamentApi.getEventCatalog(tournamentId as string),
    enabled: Boolean(tournamentId),
    retry: false,
  });
}
